<template lang="pug">
v-card(:to="to", width="300px")
  v-img(:src="img + '?resize=1&w=300'", :aspect-ratio="1.3", :alt="title")
  v-card-subtitle.pb-0.font-weight-bold(:datetime="date") {{ time }}
  v-card-title.black--text.text-uppercase.font-weight-bold.article-card-title.py-2.text-body-1 {{ title }}
  v-card-text.black--text {{ textWithoutHTML }}
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    date: {
      type: String,
    },
  },

  computed: {
    time() {
      return this.date
        ? new Intl.DateTimeFormat("pt-BR", { dateStyle: "full" }).format(
            new Date(this.date)
          )
        : "";
    },
    textWithoutHTML() {
      let d = document.createElement("div");
      d.innerHTML = this.text;
      return d.textContent;
    },
  },
};
</script>

<style>
.article-card-title {
  line-height: 20px !important;
}
</style>
